<script setup lang="ts">
import { VCardText } from 'vuetify/components';
import AppModal from './AppModal.vue';

defineProps<{ title: string }>();
</script>

<template>
    <AppModal :title :width="552" height="auto" persistent>
        <template #activator="{ props: activatorProps }">
            <slot name="activator" :props="activatorProps" />
        </template>
        <v-card-text class="pa-8">
            <slot />
        </v-card-text>
    </AppModal>
</template>
